@if ((ready$ | async)) {
  <div style="display:flex; flex-flow:column;">
    <app-stepper></app-stepper>
    <app-product-step></app-product-step>
    @if ((isColorStep$ | async)) {
      <app-color-step></app-color-step>
    }
    @if ((isQtyStep$ | async) && !(isCompProduct$ | async)) {
      <app-quantity-step></app-quantity-step>
    }
    @if ((isCompProduct$ | async)) {
      <app-comp-product-container></app-comp-product-container>
    }
    @if ((isSummaryStep$ | async)) {
      <app-summary-step></app-summary-step>
    }
  </div>
}
